module.exports = __webpack_public_path__ + "img/cancel1.e99350bb.jpg";